/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Box, Grid, Link, Typography } from '@mui/material';
import moment from 'moment';
import * as selectorsJornada from '../../../store/jornada/reducer';
import * as actionsJornada from '../../../store/jornada/actions';
import * as Role from '../../../constants/role';
import { JORNADA_ITEM_TIPOS } from '../../../constants/jornadaItemTipo';
import {
  DialogDefaultV2,
  InputV2,
  InputFormatV2,
  UsuarioSelectV2,
  OptionSelectV2,
  DatePickerV2,
} from '../../../components/v2';
import { convertTimeToMinutes, formatToTime } from 'utils';
import {
  computeJornadaTotalMinutes,
  formatEnderecoItem,
  itensByTipo,
  mapsUrlFromItem,
  timesFromItens,
} from '../../../helpers/jornadaHelpers';

const Formulario = ({
  open,
  id,
  onClose,
  loadJornada,
  jornada,
}) => {
  const [values, setValues] = useState({
    data: moment().valueOf(),
    tipoControle: 'CONTROLE_JORNADA',
    itens: [],
  });

  const byTipo = useMemo(() => itensByTipo(values.itens), [values.itens]);

  useEffect(() => {
    if (id) loadJornada(id);
  }, [id, loadJornada]);

  useEffect(() => {
    if (id && jornada && id === jornada.id) {
      const times = timesFromItens(jornada.itens);
      const totalMinutes = computeJornadaTotalMinutes(times, convertTimeToMinutes)
        || jornada.jornadaTotalMinutes;
      setValues({
        ...jornada,
        ...times,
        data: moment(parseInt(jornada.data, 10)).valueOf(),
        itens: jornada.itens || [],
        jornadaTotal: totalMinutes
          ? formatToTime(totalMinutes)
          : (jornada.jornadaTotal || null),
      });
    } else if (!id) {
      setValues({
        data: moment().valueOf(),
        tipoControle: 'CONTROLE_JORNADA',
        itens: [],
      });
    }
  }, [jornada, id]);

  const onCloseLocal = () => {
    setValues({
      data: moment().valueOf(),
      tipoControle: 'CONTROLE_JORNADA',
      itens: [],
    });
    onClose(false);
  };

  const renderItemBlock = ({ tipo, timeField, label }) => {
    const item = byTipo[tipo];
    const endereco = formatEnderecoItem(item?.enderecoJson);
    const mapsUrl = mapsUrlFromItem(item);
    const coords = item?.latitude && item?.longitude
      ? `${item.latitude}, ${item.longitude}`
      : null;
    const fotoUrl = item?.foto?.url;

    return (
      <Grid key={tipo} size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
            <InputFormatV2
              label={label}
              value={values[timeField]}
              onChange={() => {}}
              format="##:##"
              placeholder="HH:MM"
              disabled
            />
        <Box sx={{ mt: 0.5 }}>
          {endereco && (
            <Typography variant="caption" color="text.secondary" component="div">
              {endereco}
            </Typography>
          )}
          {coords && (
            <Typography variant="caption" color="text.secondary" component="div">
              {coords}
              {item?.precisaoMetros ? ` (±${item.precisaoMetros} m)` : ''}
            </Typography>
          )}
          {mapsUrl && (
            <Link href={mapsUrl} target="_blank" rel="noopener noreferrer" variant="caption">
              Ver no Maps
            </Link>
          )}
          {fotoUrl && (
            <Box sx={{ mt: 0.5 }}>
              <Link href={fotoUrl} target="_blank" rel="noopener noreferrer" variant="caption">
                Ver foto
              </Link>
            </Box>
          )}
        </Box>
      </Grid>
    );
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onCloseLocal}
      handlerConfirm={onCloseLocal}
      title="Jornada Medição"
      maxWidth="md"
      fullWidth
      readOnly
    >
      <Grid container spacing={1} sx={{ mt: 0 }}>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <DatePickerV2
            label="Data"
            value={values.data}
            onChange={() => {}}
            disabled
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <OptionSelectV2
            label="Tipo de Serviços"
            codigo="TIPO_SERVICO"
            value={values.tipoServico}
            onSelect={() => {}}
            disabled
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <InputV2
            label="Cidade"
            name="cidade"
            value={values.cidade || ''}
            onChange={() => {}}
            disabled
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <UsuarioSelectV2
            label="Inspetor"
            grupos={[Role.ADMIN, Role.INSPETOR]}
            value={values.inspetor}
            onSelect={() => {}}
            disabled
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <UsuarioSelectV2
            label="Parceiro"
            grupos={[Role.ADMIN, Role.INSPETOR]}
            value={values.inspetorAuxiliar}
            onSelect={() => {}}
            disabled
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <InputV2 label="Hora Total Trabalhada" disabled value={values.jornadaTotal || ''} />
        </Grid>
        {JORNADA_ITEM_TIPOS.map(renderItemBlock)}
      </Grid>
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  loadJornada: PropTypes.func.isRequired,
  jornada: PropTypes.object,
};

const mapStateToProps = (state) => ({
  jornada: selectorsJornada.getSelectedJornada(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...actionsJornada,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
